import { render, staticRenderFns } from "./RequestCertificate.vue?vue&type=template&id=365d8f7d&scoped=true&"
import script from "./RequestCertificate.vue?vue&type=script&lang=js&"
export * from "./RequestCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d8f7d",
  null
  
)

export default component.exports